import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

import IconLicence from './index';
import { licenceStatus, LICENCE_STATUS_LABEL } from '../actions/licenceStatus';
import { returnTypeName } from '../actions/returnTypeName';

/**
 * Campo in sola lettura con icona e stato della licenza (es. "Licenza 3 anni scaduta").
 * Usato nelle righe espanse di player e licenze.
 */
export function LicenceStatusField({ licence }) {
    const status = licenceStatus(licence);

    return (
        <TextField
            value={LICENCE_STATUS_LABEL[status]}
            label="Tipo licenza"
            variant='standard'
            InputProps={{
                readOnly: true,
                startAdornment: <InputAdornment position="start"><IconLicence typeIcon={status} forDevice /></InputAdornment>
            }}
        />
    );
}

/**
 * Campo in sola lettura con il prodotto della licenza: nome leggibile e codice productName.
 * Es. "Player 3 anni (VIDEO-PLAYER-THREE-YEARS)".
 */
export function LicenceProductField({ licence }) {
    const code = licence && licence.productName;
    const label = code ? returnTypeName(code) : '';

    return (
        <TextField
            value={!code ? '-' : (label && label !== code ? `${label} (${code})` : code)}
            label="Prodotto"
            variant='standard'
            InputProps={{ readOnly: true }}
        />
    );
}
